import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetOrganizationByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type GetOrganizationByIdQuery = { __typename?: 'query_root', organizations: Array<{ __typename?: 'organizations', id: any, name: string, contact_name?: string | null, email?: string | null, type?: string | null, jurisdiction_id?: any | null, nav_profile?: string | null, organizationImageURL?: string | null, workspace_id: any, created_at?: any | null, updated_at?: any | null, jurisdiction?: { __typename?: 'jurisdictions', id: any, name: string, short_name: string, state: string, ahj_type: string } | null, org_properties: Array<{ __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, premium?: boolean | null, tier_status?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null, property_users: Array<{ __typename?: 'user_properties', user?: { __typename?: 'users', id: string, first_name: string, last_name: string, email: string, profile_photo?: string | null, phone_number?: string | null, role?: string | null, title?: string | null } | null }> }> }> };


export const GetOrganizationByIdDocument = gql`
    query getOrganizationById($id: uuid!) {
  organizations(where: {id: {_eq: $id}, deleted_at: {_is_null: true}}) {
    id
    name
    contact_name
    email
    type
    jurisdiction_id
    nav_profile
    jurisdiction {
      id
      name
      short_name
      state
      ahj_type
    }
    organizationImageURL
    workspace_id
    created_at
    updated_at
    org_properties(where: {deleted_at: {_is_null: true}}) {
      id
      name
      address
      address_id
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
        country
      }
      premium
      tier_status
      property_users(where: {user: {deleted_at: {_is_null: true}}}) {
        user {
          id
          first_name
          last_name
          email
          profile_photo
          phone_number
          role
          title
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationByIdQuery__
 *
 * To run a query within a React component, call `useGetOrganizationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables> & ({ variables: GetOrganizationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>(GetOrganizationByIdDocument, options);
      }
export function useGetOrganizationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>(GetOrganizationByIdDocument, options);
        }
export function useGetOrganizationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>(GetOrganizationByIdDocument, options);
        }
export type GetOrganizationByIdQueryHookResult = ReturnType<typeof useGetOrganizationByIdQuery>;
export type GetOrganizationByIdLazyQueryHookResult = ReturnType<typeof useGetOrganizationByIdLazyQuery>;
export type GetOrganizationByIdSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationByIdSuspenseQuery>;
export type GetOrganizationByIdQueryResult = Apollo.QueryResult<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>;